import { TimelineLite, Power2 } from 'gsap'
import { rectangleOverlap } from './utils/math'
import bus from './bus'
import UI from './utils/UI'
import getViewport from './utils/get-viewport'

UI({
  component: '.js-pageStagger',
  items: ['.js-pageStagger-item']
}, ({ component, items }) => {
  const tl = new TimelineLite({ onComplete: _ => bus.emit('page-stagger-ready'), paused: true })
  const animateOn = component.dataset.animateOn
  const viewport = getViewport()
  const itemsToAnimate = items.reduce((res, item) => {
    if (rectangleOverlap(item.getBoundingClientRect(), viewport)) {
      res.push(item)
    }
    return res
  }, [])

  itemsToAnimate.forEach((item, index) => tl.to(item, 0.2, { opacity: 1, ease: Power2.easeInOut }, index === 0 ? 0 : '-=0.15'))
  tl.timeScale(items.length / 1.5)

  items.forEach(item => {
    if (itemsToAnimate.indexOf(item) === -1) {
      item.style.opacity = 1
    }
  })

  if (animateOn) {
    bus.on(animateOn, _ => tl.paused(false))
  } else {
    tl.paused(false)
  }
})
